export const getCountry = (countryCode, countryList) => {
  return countryList.find(x => x.code === countryCode);
};

export const mapCountryListForSelect = countryList => {
  return [
    { key: 1, value: null, displayName: '' },
    ...countryList.map(country => {
      return { key: country.code, value: country.code, displayName: country.name };
    }),
  ];
};
